import PropTypes from 'prop-types'
import querystring from 'querystring'
import React from 'react'
import HostedCheckoutButton from './HostedCheckoutButton.jsx'
import HostedPaymentMethodButton from './HostedPaymentMethodButton.jsx'
import ReactivateAccountButton from './ReactivateAccountButton.jsx'

const HostedPageButton = ({ team, user, setTeam }) => {
  switch (team.subscription.status) {
    case 'trail':
      return (
        <HostedPaymentMethodButton team={team} user={user} setTeam={setTeam} />
      )

    case 'cancelled':
      if ((team.subscription.paymentInfo || []).length) {
        const queryParams = querystring.parse(
          window.location.href.split('?')[1]
        )
        const shouldReactivate = Boolean(queryParams.reactivate)
        const onSuccess = () => (window.location = window.location.pathname)
        return (
          <ReactivateAccountButton
            team={team}
            onSuccess={onSuccess}
            reactivateImmediately={shouldReactivate}
          />
        )
      } else {
        return (
          <HostedPaymentMethodButton
            team={team}
            user={user}
            buttonLabelId='setting.subscription.reactivateButtonLabel'
            setTeam={setTeam}
          />
        )
      }

    default:
      return (
        <div className='col'>
          <HostedCheckoutButton team={team} />
        </div>
      )
  }
}

const propTypes = {
  team: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  setTeam: PropTypes.func
}

HostedPageButton.propTypes = propTypes

const PaymentButtons = props => (
  <>
    <div className='paymentrow'>
      <HostedPageButton {...props} />
    </div>
  </>
)

PaymentButtons.propTypes = propTypes

export default PaymentButtons
